/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllergenPropertyKind =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type LocationByAddressInput = {
  readonly address1?: string | null | undefined;
  readonly address2?: string | null | undefined;
  /** id for an address present in the current session. */
  readonly addressId?: string | number | null | undefined;
  readonly city?: string | null | undefined;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: string | null | undefined;
  readonly lat?: number | null | undefined;
  readonly lon?: number | null | undefined;
  readonly state?: string | null | undefined;
  readonly useCartRestaurant?: boolean | null | undefined;
  readonly zipcode?: number | null | undefined;
};

export type HomePickupMenuQueryVariables = Exact<{
  id: string | number;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type HomePickupMenuQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly showDeliveryFeeDisclosure: boolean;
    readonly menu: {
      readonly __typename: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename: 'MenuCategory';
        readonly id: string;
        readonly products: ReadonlyArray<{
          readonly __typename: 'Product';
          readonly id: string;
          readonly slug: string;
          readonly isModifiable: boolean;
          readonly name: string;
          readonly description: string;
          readonly cost: number;
          readonly baseProduct: {
            readonly __typename: 'BaseProduct';
            readonly id: string;
            readonly slug: string;
            readonly lineageKey: string | null;
            readonly calories: number | null;
            readonly totalFatG: number | null;
            readonly totalCarbsG: number | null;
            readonly dietaryFiberG: number | null;
            readonly sugarsG: number | null;
            readonly proteinG: number | null;
          };
          readonly asset: { readonly url: string };
          readonly allergenProperties: ReadonlyArray<{
            readonly __typename: 'AllergenProperty';
            readonly id: string;
            readonly name: Types.AllergenPropertyKind;
          }>;
        }>;
      }>;
    };
  } | null;
};

export type HomeDeliveryMenuQueryVariables = Exact<{
  input: Types.LocationByAddressInput;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type HomeDeliveryMenuQuery = {
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly deliveryFee: number;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly showDeliveryFeeDisclosure: boolean;
          readonly menu: {
            readonly __typename: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename: 'MenuCategory';
              readonly id: string;
              readonly products: ReadonlyArray<{
                readonly __typename: 'Product';
                readonly id: string;
                readonly slug: string;
                readonly isModifiable: boolean;
                readonly name: string;
                readonly description: string;
                readonly cost: number;
                readonly baseProduct: {
                  readonly __typename: 'BaseProduct';
                  readonly id: string;
                  readonly slug: string;
                  readonly lineageKey: string | null;
                  readonly calories: number | null;
                  readonly totalFatG: number | null;
                  readonly totalCarbsG: number | null;
                  readonly dietaryFiberG: number | null;
                  readonly sugarsG: number | null;
                  readonly proteinG: number | null;
                };
                readonly asset: { readonly url: string };
                readonly allergenProperties: ReadonlyArray<{
                  readonly __typename: 'AllergenProperty';
                  readonly id: string;
                  readonly name: Types.AllergenPropertyKind;
                }>;
              }>;
            }>;
          };
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type HomeMenuFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly showDeliveryFeeDisclosure: boolean;
  readonly menu: {
    readonly __typename: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename: 'MenuCategory';
      readonly id: string;
      readonly products: ReadonlyArray<{
        readonly __typename: 'Product';
        readonly id: string;
        readonly slug: string;
        readonly isModifiable: boolean;
        readonly name: string;
        readonly description: string;
        readonly cost: number;
        readonly baseProduct: {
          readonly __typename: 'BaseProduct';
          readonly id: string;
          readonly slug: string;
          readonly lineageKey: string | null;
          readonly calories: number | null;
          readonly totalFatG: number | null;
          readonly totalCarbsG: number | null;
          readonly dietaryFiberG: number | null;
          readonly sugarsG: number | null;
          readonly proteinG: number | null;
        };
        readonly asset: { readonly url: string };
        readonly allergenProperties: ReadonlyArray<{
          readonly __typename: 'AllergenProperty';
          readonly id: string;
          readonly name: Types.AllergenPropertyKind;
        }>;
      }>;
    }>;
  };
};

export const HomeMenuFragmentDoc = gql`
  fragment HomeMenu on Restaurant {
    id
    __typename
    showDeliveryFeeDisclosure
    menu {
      id
      __typename
      categories {
        id
        __typename
        products {
          id
          __typename
          slug
          isModifiable
          baseProduct {
            __typename
            id
            slug
            lineageKey
            calories
            totalFatG
            totalCarbsG
            dietaryFiberG
            sugarsG
            proteinG
          }
          asset {
            url
          }
          name
          description
          cost: channelCost(costChannel: $costChannel)
          allergenProperties {
            id
            __typename
            name
          }
        }
      }
    }
  }
`;
export const HomePickupMenuDocument = gql`
  query HomePickupMenu($id: ID!, $costChannel: CostChannel) {
    restaurant(id: $id) {
      ...HomeMenu
    }
  }
  ${HomeMenuFragmentDoc}
`;

export function useHomePickupMenuQuery(
  options: Omit<Urql.UseQueryArgs<HomePickupMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomePickupMenuQuery, HomePickupMenuQueryVariables>({
    query: HomePickupMenuDocument,
    ...options,
  });
}
export const HomeDeliveryMenuDocument = gql`
  query HomeDeliveryMenu($input: LocationByAddressInput!, $costChannel: CostChannel) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        deliveryFee
        restaurant {
          ...HomeMenu
        }
      }
    }
  }
  ${HomeMenuFragmentDoc}
`;

export function useHomeDeliveryMenuQuery(
  options: Omit<Urql.UseQueryArgs<HomeDeliveryMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomeDeliveryMenuQuery, HomeDeliveryMenuQueryVariables>({
    query: HomeDeliveryMenuDocument,
    ...options,
  });
}
